import { experienceQueryKeys as e } from "../experiences/useExperienceQueryKeys.mjs";
import { runInventoryMediaUpload as t } from "./runInventoryMediaUpload.mjs";
import { serviceQueryKeys as n } from "../services/useServiceQueryKeys.mjs";
import { inventoryMediaQueryKeys as r } from "./useInventoryMediaQueryKeys.mjs";
import { useMutation as i, useQueryClient as a } from "@maat/store-hooks";
import { experiencesApi as o, servicesApi as s } from "@maat/api-main";
//#region src/inventoryMedia/useUploadInventoryMediaMutation.ts
var c = (e, t) => (n) => e === "experience" ? o.presignExperienceMedia(t, { media: n }) : s.presignServiceMedia(t, { media: n }), l = () => {
	let o = a();
	return i({
		mutationFn: ({ kind: e, inventoryId: n, media: r, onUploadProgress: i }) => t({
			groups: r.map(({ category: e, images: t }) => ({
				category: e,
				files: t
			})),
			presign: c(e, n),
			onUploadProgress: i
		}),
		onSuccess: (t, { kind: i, inventoryId: a }) => {
			o.invalidateQueries({ queryKey: r.images(i, a) }), i === "experience" ? o.invalidateQueries({ queryKey: e.detail(a) }) : o.invalidateQueries({ queryKey: n.detail(a) });
		}
	});
};
//#endregion
export { l as useUploadInventoryMediaMutation };
